// extracted by mini-css-extract-plugin
export default {"variationToggle":"variationToggle_variationToggle__xlLgH","variation":"variationToggle_variation__RReew","variationColor":"variationToggle_variationColor__Rqy8-"};